export default {"src":"/_next/static/media/tiktok-logo.cb71c899.svg","height":42,"width":43};